/**
 * 全局环境配置
 * 域名信息，其他信息等按环境预设配置
 */

const CDN_PROJECT_NAME = 'exam-lib-fe';
export const GlobalEnvConfigMap = {
  dev: {
    origin: 'http://examlocal.51cto.com',
    assetsBase: './',
    assetsHost: 'https://s5-edu.51cto.com/',
    sensorsServerUrl: 'https://sc.51cto.com/sa?project=default',
    examUrl: 'http://examlocal.51cto.com',
    eduUrl: 'http://edulocal.51cto.com',
    homeUrl: 'http://homelocal.51cto.com',
    eUrl: 'http://trainlocal.51cto.com',
  },
  test: {
    origin: 'https://test-t.51cto.com',
    assetsHost: 'https://static-test.51cto.com/',
    assetsBase: `https://static-test.51cto.com/edu/${CDN_PROJECT_NAME}-test`,
    sensorsServerUrl: 'https://sc.51cto.com/sa?project=default',
    examUrl: 'https://test-t.51cto.com',
    eduUrl: 'https://test-edu.51cto.com',
    homeUrl: 'https://test-home.51cto.com',
    eUrl: 'http://linetraining.51cto.com',
  },
  stage: {
    origin: 'https://stage-t.51cto.com',
    assetsHost: 'https://static-test.51cto.com/',
    assetsBase: `https://static-test.51cto.com/edu/${CDN_PROJECT_NAME}-stage`,
    sensorsServerUrl: 'https://sc.51cto.com/sa?project=default',
    examUrl: 'https://stage-t.51cto.com',
    eduUrl: 'https://stage-edu.51cto.com',
    homeUrl: 'https://stage-home.51cto.com',
    eUrl: 'https://stage-e.51cto.com',
  },
  uat: {
    origin: 'https://t.51cto.com',
    assetsHost: 'https://static-test.51cto.com/',
    assetsBase: `https://static-test.51cto.com/edu/${CDN_PROJECT_NAME}-uat`,
    sensorsServerUrl: 'https://sc.51cto.com/sa?project=production',
    examUrl: 'https://t.51cto.com',
    eduUrl: 'https://edu.51cto.com',
    homeUrl: 'https://home.51cto.com',
    eUrl: 'https://e.51cto.com',
  },
  production: {
    origin: 'https://t.51cto.com',
    assetsHost: 'https://s5-edu.51cto.com/',
    assetsBase: `https://s5-edu.51cto.com/edu/${CDN_PROJECT_NAME}`,
    sensorsServerUrl: 'https://sc.51cto.com/sa?project=production',
    examUrl: 'https://t.51cto.com',
    eduUrl: 'https://edu.51cto.com',
    homeUrl: 'https://home.51cto.com',
    eUrl: 'https://e.51cto.com',
  },
};

export type ENV_TYPE = keyof typeof GlobalEnvConfigMap;

export function getEnvConfig(env: ENV_TYPE) {
  const currentEnv = GlobalEnvConfigMap[env];

  return {
    origin: currentEnv.origin,
    assetsBase: currentEnv.assetsBase,
    assetsHost: currentEnv.assetsHost,
    sensorsServerUrl: currentEnv.sensorsServerUrl,
    examUrl: currentEnv.examUrl,
    eduUrl: currentEnv.eduUrl,
    homeUrl: currentEnv.homeUrl,
    eUrl: currentEnv.eUrl,
  };
}
